import { sectionVariants } from "@/types";
import { BuilderElement } from "@builder.io/sdk";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function normalizeKey(str: string) {
  return str.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
}

export const spacingClasses: Record<string, string> = {
  none: 'py-0',
  small: 'py-4 md:py-6 xl:py-8',
  medium: 'py-6 md:py-10 xl:py-16',
  large: 'py-10 md:py-16 xl:py-20',
  xlarge: 'py-12 md:py-30 xl:py-40'
};

export const spacingClassesHero: Record<string, string> = {
  none: 'py-0',
  small: 'pt-2 md:pt-4 xl:pt-6 pb-4 md:pb-6 xl:pb-8',
  medium: 'pt-4 md:pt-6 xl:pt-8 pb-6 md:pb-10 xl:pb-16',
  large: 'pt-6 md:pt-10 xl:pt-16 pb-10 md:pb-16 xl:pb-20',
  xlarge: 'pt-10 md:pt-16 xl:pt-20 pb-14 md:pb-30 xl:pb-40'
};

export function sectionBackgroundColors(darkMode: boolean, variant: sectionVariants) {
  if (darkMode) {
    switch (variant) {
      case "A":
        return "bg-background";
      case "B":
        return "bg-muted";
      default:
        return "bg-background";
    }
  } else {
    switch (variant) {
      case "A":
        return "bg-background";
      case "B":
        return "bg-muted";
      default:
        return "bg-background";
    }
  }
}

//this is same as actionBackgroundColors but for variant
export function variantBackgroundColors(darkMode: boolean, variant: sectionVariants) {
  if (darkMode) {
    switch (variant) {
      case "A":
        return "bg-muted";
      case "B":
        return "bg-background";
      default:
        return "bg-muted";
    }
  } else {
    switch (variant) {
      case "A":
        return "bg-muted";
      case "B":
        return "bg-background";
      default:
        return "bg-muted";
    }
  }
}

export function actionBackgroundColors(darkMode: boolean, variant: sectionVariants) {
  if (darkMode) {
    switch (variant) {
      case "A":
        return "bg-muted";
      case "B":
        return "bg-background";
      default:
        return "bg-muted";
    }
  } else {
    switch (variant) {
      case "A":
        return "bg-muted";
      case "B":
        return "bg-background";
      default:
        return "bg-muted";
    }
  }
}

export function hoverBackgroundColors(darkMode: boolean, variant: sectionVariants) {
  if (darkMode) {
    switch (variant) {
      case "A":
        return "bg-accent";
      case "B":
        return "bg-background";
      default:
        return "bg-accent";
    }
  } else {
    switch (variant) {
      case "A":
        return "bg-accent";
      case "B":
        return "bg-background";
      default:
        return "bg-accent";
    }
  }
}

export function getPageContext(BuilderElements?: BuilderElement[]) {
  if (!BuilderElements) return { headerProps: null, footerProps: null };

  const headerSymbol = BuilderElements?.find((block: BuilderElement) => block?.component?.options?.symbol?.content?.name === "Header");
  const footerSymbol = BuilderElements?.find((block: BuilderElement) => block?.component?.options?.symbol?.content?.name === "Footer");

  return {
    headerProps: headerSymbol?.component?.options?.symbol?.data,
    footerProps: footerSymbol?.component?.options?.symbol?.data,
  }
}

/**
 * Escapes dangerous characters in HTML attribute values
 * Handles: double quotes, single quotes, ampersands, angle brackets, newlines, null bytes
 * Note: React automatically escapes these, but this provides extra safety for edge cases
 */
export function escapeHtmlAttribute(value: string | undefined | null): string {
  if (!value) return '';
  
  return value
    .replace(/&/g, '&amp;')      // Must be first to avoid double-escaping
    .replace(/"/g, '&quot;')      // Double quotes
    .replace(/'/g, '&#x27;')      // Single quotes (apostrophe)
    .replace(/</g, '&lt;')        // Less than
    .replace(/>/g, '&gt;')        // Greater than
    .replace(/\n/g, ' ')          // Newlines
    .replace(/\r/g, ' ')          // Carriage returns
    .replace(/\0/g, '');          // Null bytes
}